import { Box, Card, Stack, IconButton, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAreas } from "src/services/request";
import ClickOutside from "./click-outside/ClickOutside";
import iconCloseCircle from "@iconify/icons-eva/close-circle-outline";
import { Icon } from "@iconify/react";

const CityPicker = ({ code, level = 3, onSelect }) => {
  const areas = useSelector((state) => state.globalData.areas);

  const [open, setOpen] = useState(false);

  const [province, setProvince] = useState(null);
  const [provinces, setProvinces] = useState(null);
  const [city, setCity] = useState(null);
  const [cities, setCities] = useState(null);
  const [district, setDistrict] = useState(null);
  const [districts, setDistricts] = useState(null);
  useEffect(() => {
    console.log("-----1-", areas, provinces);
    if (!areas) {
      getAreas();
    } else if (!provinces) {
      setProvinces(areas.filter((a) => a.pid === 100000));
      setDistrict(areas.find((a) => a.id === code));
    }
  }, [areas, code]);

  if (!provinces) return null;

  function handleProvinceClick(p) {
    if (province && province.id === p.id) return;
    setProvince(p);
    setCities(areas.filter((a) => a.pid === p.id));
    setDistricts(null);
    if (level == 1) {
      handleSelect(p);
      setOpen(false);
    }
  }

  function handleCityClick(c) {
    if (city && city.id === c.id) return;
    setCity(c);
    setDistricts(areas.filter((a) => a.pid === c.id));

    if (level == 2) {
      handleSelect(c);
      setOpen(false);
    }
  }

  function handleDistrictClick(e, district) {
    e.stopPropagation();
    // setCity(city);
    // setDistricts(areas.filter((a) => a.pid === city.id));
    setDistrict(district);
    setOpen(false);
    // onSelect(district);
    handleSelect(district);
  }

  function handleClear(e) {
    e.stopPropagation();

    setProvince("");
    setCity("");
    setDistrict("");
    setOpen(false);
    onSelect({});
  }

  function handleSelect(cur) {
    setTimeout(() => {
      const data = {
        province: province,
        city: city,
        district: district,
      };
      if (level == 1) {
        data.province = cur;
      }
      if (level == 2) {
        data.city = cur;
      }
      if (level == 3) {
        data.district = cur;
      }

      onSelect(data);
    }, 10);
  }

  function renderArea() {
    if (district) {
      let city = areas.find((a) => a.id === district.pid)
      let province = areas.find((a) => a.id === city.pid)
      return province.name+city.name+`${district.name}`;
    }

    // return "请选择地区";
    return "";
  }

  return (
    <ClickOutside onClickOutside={() => setOpen(false)}>
      {/* <Box className="rc" sx={{ pl: 2, position: "relative", width: 300, height: 40, borderRadius: "10px", border: "1px solid rgba(145, 158, 171, 0.32)" }}> */}
      {/* <div onClick={() => setOpen(true)} style={{flex: 1}}>{renderArea()}</div> */}

      <TextField
        label="地区选择"
        size="small"
        value={renderArea()}
        onFocus={() => {
          setOpen(true);
        }}
      />

      <Card sx={{ position: "absolute", top: "", zIndex: 11, borderRadius: "10px", opacity: open ? 1 : 0, pointerEvents: open ? "all" : "none" }}>
        <Stack direction="row" sx={{ height: 200, overflow: "hidden" }}>
          <Box sx={{ width: 200, borderRadius: "10px", overflow: "auto" }}>
            {provinces.map((p, i) => {
              return (
                <div className="rc" key={i} style={{ padding: "5px 20px", color: province && p.id == province.id ? "red" : "unset" }} onClick={() => handleProvinceClick(p)}>
                  {p.name}
                </div>
              );
            })}
          </Box>
          {cities && (
            <Box sx={{ width: 200, borderRadius: "10px", overflow: "auto" }}>
              {cities.map((c, i) => {
                return (
                  <div className="rc" key={i} style={{ padding: "5px 20px", color: city && c.id == city.id ? "red" : "unset" }} onClick={() => handleCityClick(c)}>
                    {c.name}
                  </div>
                );
              })}
            </Box>
          )}
          {districts && (
            <Box sx={{ width: 200, borderRadius: "10px", overflow: "auto" }}>
              {districts.map((d, i) => {
                return (
                  <div className="rc" key={i} style={{ padding: "5px 20px", color: district && d.id == district.id ? "red" : "unset" }} onClick={(e) => handleDistrictClick(e, d)}>
                    {d.name}
                  </div>
                );
              })}
            </Box>
          )}
        </Stack>
      </Card>

      {district && (
        <IconButton onClick={handleClear} style={{ position: "relative", zIndex: 11 }}>
          <Icon icon={iconCloseCircle} />
        </IconButton>
      )}
      {/* </Box> */}
    </ClickOutside>
  );
};

export default CityPicker;
